export const positionPillars = [
  {
    icon: "ri-discuss-line",
    title: "把讨论聚起来",
    desc: "把散落在各处的观点收拢到同一个话题下,你不需要翻几十个帖子,也能看清一件事的来龙去脉。",
  },
  {
    icon: "ri-eye-line",
    title: "让角度被看见",
    desc: "同一个事件,有人关注细节,有人在意情绪。我们尽量让不同的声音都有位置,而不是只留下最大声的那一种。",
  },
  {
    icon: "ri-time-line",
    title: "跟得上热点",
    desc: "热门话题实时滚动,从出现到降温的每个阶段,社区里都有人正在聊。你随时进来,都不会觉得错过太多。",
  },
];

export const principles = [
  { title: "先看完整,再开口", desc: "鼓励在评论前多了解一点背景。很多争论其实源于大家看到的是不同的片段。" },
  { title: "对事不对人", desc: "可以犀利地讨论观点,但不针对个人进行攻击。讨论的价值在于观点,不在于输赢。" },
  { title: "不传播未经证实的信息", desc: "对于来源不明的说法,我们会标注提醒,也希望大家转发前先停三秒。" },
  { title: "尊重不同的喜好", desc: "喜欢和不喜欢都是合理的。你可以不认同,但不必否定别人的热爱。" },
];

export const testimonials = [
  { name: "追剧的橘子", role: "影视区常驻楼主", text: "在这里发帖最大的感受是,大家真的会认真读你说的话,然后给出有理有据的回应,而不是一句「你行你上」。", stars: 5 },
  { name: "网感研究所", role: "热点区观察者", text: "热点更新很快,但社区不会只追着热度跑。有几次我发的冷门观察,也照样有人愿意坐下来讨论。", stars: 5 },
  { name: "现场第一排", role: "演出区资深乐迷", text: "演出体验那篇整理帖,后台收到了很多补充。这种大家一起把一件事讲清楚的感觉,挺难得的。", stars: 4 },
  { name: "综艺观察员", role: "综艺区活跃网友", text: "评论区氛围是我待过的社区里比较舒服的,可以放心说出不同意见,不用怕被群嘲。", stars: 5 },
];

export const contactChannels = [
  { icon: "ri-mail-line", label: "社区合作", value: "hello@17.cn" },
  { icon: "ri-feedback-line", label: "内容反馈", value: "report@17.cn" },
  { icon: "ri-user-heart-line", label: "加入创作者", value: "join@17.cn" },
];